module.exports = __webpack_public_path__ + "img/icon-warning-stormsurge-yellow.4759d2de.svg";